module.exports = __webpack_public_path__ + "img/cwell1.b8e727ce.jpg";